/*
 * @Author: Json Chen
 * @Date: 2021-07-23 15:51:12
 * @LastEditTime: 2022-06-13 17:53:28
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/Components/ParcelLockers.tsx
 */

import { DragNDrop } from '@/src/components';
import { randomNumber } from '@/src/tools/helper';
import { MenuOutlined } from '@ant-design/icons';
import { useVirtualList } from 'ahooks';
import { Checkbox, Col, Collapse, Row } from 'antd';
import _, { get } from 'lodash';
import React, { useMemo } from 'react';
import { Select } from 'src/components/Antd';
import styles from '../style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  value?: any[];
  onChange?: any;
  parcelLockers: any[];
  disableEdit?: boolean;
}

enum regionType {
  MO = 'MO',
  HK = 'HK',
}
export const regionTypeList = {
  [regionType.MO]: 'Macau SAR',
  [regionType.HK]: 'Hong Kong SAR',
};

const ParcelLockers = ({
  value = [],
  onChange,
  parcelLockers,
  disableEdit,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const parcelLockersOptions = (parcelLockers || []).map((item) => ({
    label: (
      <div>
        <div>{item.name || ''}</div>
        <span className={styles.selectItemIntroduce}>
          {get(item, 'courierAccount.name', '')}
        </span>
      </div>
    ),
    value: item.uuid,
  }));

  const list = useMemo(() => {
    return (value || []).map((item) => {
      return {
        draggableId: item.draggableId ? item.draggableId : randomNumber(),
        name: regionTypeList[item.region],
        indeterminate:
          item.types.some((i) => i.checked) &&
          !item.types.every((i) => i.checked),
        checked: item.types.every((i) => i.checked),
        storeParcelLockerUuid: item.storeParcelLockerUuid,
        types: item.types,
      };
    });
  }, [value]);
  const onSort = (oldIndex, newIndex) => {
    const _value = _.cloneDeep(value);
    const old = _value.splice(oldIndex, 1)[0];
    _value.splice(newIndex, 0, old);
    onChange(_value);
  };
  const onCheckAllChange = (checkedAll, index) => {
    const _value = _.cloneDeep(value);
    onChange(
      _value.map((item, index1) => {
        return index1 === index
          ? {
              ...item,
              types: item.types.map((t, index2) => ({
                ...t,
                checked: checkedAll,
              })),
            }
          : item;
      }),
    );
  };
  const onCheckItemChange = (checked, index, typeIndex) => {
    const _value = _.cloneDeep(value);
    onChange(
      _value.map((item, index1) => {
        return index1 === index
          ? {
              ...item,
              types: item.types.map((t, index2) => {
                return index2 === typeIndex ? { ...t, checked: checked } : t;
              }),
            }
          : item;
      }),
    );
  };

  const handleParcelLockerChange = (select, index) => {
    const _value = _.cloneDeep(value);
    onChange(
      _value.map((item, index1) => {
        return index1 === index
          ? {
              ...item,
              storeParcelLockerUuid: select,
            }
          : item;
      }),
    );
  };

  return (
    <div className={styles.parcelLocakerContainer}>
      <div className={styles.parcelLocakerSFContainer}>
        <div className={styles.sfExpress}>
          {getI18n('salesChannelLogistics.index.sFExpress')}
        </div>
        <DragNDrop
          droppableId={'ParcelLockersCheckbox'}
          disableAllDrags={disableEdit}
          list={list}
          childGenerator={(item: any, provided, index) => {
            const showSelect = (item.types || []).filter((o) => o.checked);
            return (
              <dl key={item.draggableId}>
                <dt>
                  <div
                    {...provided.dragHandleProps}
                    className={styles.dragIcon}>
                    <MenuOutlined
                      style={{ fontSize: '13px', color: '#61D77C' }}
                    />
                  </div>
                  <Checkbox
                    disabled={disableEdit}
                    indeterminate={item.indeterminate}
                    checked={item.checked}
                    onChange={(e) => onCheckAllChange(e.target.checked, index)}>
                    {item.name}
                  </Checkbox>
                </dt>
                <div className={styles.parcelLockerItems}>
                  <Select
                    className={styles.parcelLockerSelect}
                    value={item.storeParcelLockerUuid}
                    options={parcelLockersOptions}
                    disabled={showSelect.length === 0 || disableEdit}
                    onChange={(value) => handleParcelLockerChange(value, index)}
                    size='large'
                  />

                  {(item?.types || []).map((type, typeIndex) => {
                    return (
                      <dd className={styles.parcelLocakerItem} key={typeIndex}>
                        <Checkbox
                          checked={type.checked}
                          disabled={disableEdit}
                          onChange={(e) =>
                            onCheckItemChange(
                              e.target.checked,
                              index,
                              typeIndex,
                            )
                          }>
                          {type.name}
                        </Checkbox>
                      </dd>
                    );
                  })}
                </div>
              </dl>
            );
          }}
          onChange={onSort}
        />
      </div>

      <div className={styles.collapseContainer}>
        <Collapse
          // className={styles.settingContentCollapse}
          expandIconPosition={'right'}
          accordion
          bordered={false}>
          {list.map((item) => {
            const isDisappear = item.types.every((t) => !t.checked);

            if (isDisappear) {
              return null;
            }

            const tables = item.types.reduce((p, c) => {
              if (!c.checked) {
                return p;
              }
              return p.concat(c.lockers);
            }, []);
            return (
              <Collapse.Panel
                key={item.name}
                forceRender
                header={
                  <div className={styles.localtionItemHeader}>
                    <div className={styles.localtionItemHeaderName}>
                      {item.name}
                    </div>
                    <div>
                      {tables.length}{' '}
                      {getI18n('salesChannelLogistics.index.locations')}
                    </div>
                  </div>
                }>
                <div className={styles.customerListTable}>
                  <div className={styles.tableHeader}>
                    <Row>
                      <Col span={4}>
                        <div>
                          {getI18n('salesChannelLogistics.index.district')}
                        </div>
                      </Col>
                      <Col span={3}>
                        <div>{getI18n('salesChannelLogistics.index.code')}</div>
                      </Col>
                      <Col span={8}>
                        <div>
                          {getI18n(
                            'salesChannelLogistics.index.lockerFullAddress',
                          )}
                        </div>
                      </Col>
                      <Col span={4}>
                        <div>
                          {getI18n('salesChannelLogistics.index.openingHours')}
                        </div>
                      </Col>
                      <Col span={5}>
                        <div>
                          {getI18n('salesChannelLogistics.index.limitations')}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <RenderTable tables={tables} />
                </div>
              </Collapse.Panel>
            );
          })}
        </Collapse>
      </div>
    </div>
  );
};

const RenderTable = ({ tables }) => {
  const { list, containerProps, wrapperProps } = useVirtualList(tables, {
    overscan: 30,
    itemHeight: 60,
  });
  return (
    <>
      <div
        className={styles.tableBody}
        {...containerProps}
        style={{ height: '300px', overflow: 'auto' }}>
        <div {...wrapperProps}>
          {list.map(({ data, index }) => (
            <div className={styles.tableItems} key={index}>
              <Row>
                <Col span={4}>
                  <div className={styles.tableItem}>{data.county}</div>
                </Col>
                <Col span={3}>
                  <div className={styles.tableItem}>{data.partnerCode}</div>
                </Col>
                <Col span={8}>
                  <div className={styles.tableItem}>{data.address}</div>
                </Col>
                <Col span={4}>
                  <div className={styles.tableItem}>{data.serviceTime}</div>
                </Col>
                <Col span={5}>
                  <div className={styles.tableItem}>{data.limitation}</div>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ParcelLockers;
